const Privacy = () => {
    return (
        <div className="flex text-start flex-col margin-x py-10">
            <>
                <p>
                    <br />
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",
                        

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "12pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        PRIVACY POLICY
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Last Updated on October 6, 2023. This Privacy Policy is effective immediately for Users after
                        that date.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb ("we," "us,") respect your privacy and are committed to protecting it through our
                        compliance with this Privacy Policy. This policy describes:
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        • the types of information that we may collect from you when you access or use our Website -
                        https://order.foodb.co.uk and other online services (collectively, our "Services"); and
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        • our practices for collecting, using, maintaining, protecting and disclosing that information.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        This policy applies only to information we collect through our Services and in the electronic
                        communications sent through or in connection with our Services.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        DEFINITIONS
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        User
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        "User" or "you" or "your" refers to you, as a user of the Services. A user is someone who
                        accesses or uses the Services for the purpose of sharing, displaying, hosting, publishing,
                        transacting, uploading information or viewing pictures and includes other persons jointly
                        participating in using the Services.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        User Account
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        "User Account" is a separate part of the Website, containing User information required by Foodb
                        during registration.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Content
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        "Content" will include (but is not limited to) images, photos, audio, video, location data,
                        'nearby places', and all other forms of information or data.&nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb qualifies as a Data Controller under the Regulation (EU) 2016/679 of The European
                        Parliament and of The Council of 27 April 2016 (General Data Protection Regulation (the
                        "GDPR")). As such, we aim to comply with all legal obligations which the GDPR implies on Data
                        Controllers.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb strives to offer its visitors and Users the many advantages of Internet technology and to
                        provide an interactive and personalized experience. For these purposes, we, from Foodb, may use
                        personally identifiable information - like your name, e-mail address, address, telephone number,
                        etc., which are subject to the terms of this Privacy Policy. We, and we suppose you too, do not
                        tolerate spam. We will therefore never sell, barter, or rent your email address to any
                        unauthorized third parties.&nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        1.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        WHAT INFORMATION DO WE COLLECT FROM OUR USERS?
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "6pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb may collect and use information of and regarding its Users. We collect only data which is
                        essential to our operations and enables us to provide you with better user experience.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        The information, through which the person may be identified, may include data, which the User
                        voluntarily enters, uses or provides when using the Services of the Foodb &nbsp;Website , or
                        submits when creating a User Account. &nbsp;Foodb collects and uses the information for the
                        purposes, outlined in this Privacy Policy, as well as to offer new services to the User or to
                        familiarise him with new functionalities on the Website.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We may also use certain performance tracking tools, such as Google Analytics. Through the use of
                        Google Analytics we gather information regarding your behaviour and preferences when using our
                        online platform.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We collect two types of information from and about our Users, including information:
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        • by which you may be personally identified; and/or
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        • about your internet connection, the equipment you use to access our Services and your usage
                        details (i.e. your Internet Service Provider).
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        The information we collect on or through our Services may include:
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",
                        textIndent: "-19pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 19pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        i.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "italic",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        User Account information:
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;Personal information, such as your full name and other information you may provide with
                        your account, such as your address and phone number, that may be displayed as a part of your
                        User Account;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;&nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",
                        textIndent: "-19pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 19pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        ii.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "italic",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Contact Information:&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Your contact information, such as email address and other ways of communication.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "59pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We collect this information in order to provide you with access to certain features of our
                        Services and to inform you about relevant information concerning your use of our Services.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "55pt",
                        marginRight: "7pt",
                        textIndent: "-14pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 14pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",
                        textIndent: "-19pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 19pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        iii.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "italic",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Preferences
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        : Your preferences and settings such as time zone and language;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "59pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We collect this information in order to enhance your user experience.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "54pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",
                        textIndent: "-19pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 19pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        v.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "italic",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Searches and other activities
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        : The search terms you have looked up and results you selected;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "59pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We collect this information in order to improve your user experience and provide you with more
                        relevant content and Services.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "54pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",
                        textIndent: "-19pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 19pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        vi.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "italic",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Browsing information
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        : How long you used our Services, which features you used, etc.;&nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",
                        textIndent: "-19pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 19pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        vii.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "italic",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Transactional information:
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;If you make payments or purchases through our Services, we may collect and store
                        information about you to process your requests and automatically complete forms for future
                        transactions;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;&nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "7pt",
                        textIndent: "-19pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 19pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        viii.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "italic",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Location Data:&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We may collect information about your location if you have instructed your mobile device or
                        computer to send such information via the privacy settings on that mobile device or computer. We
                        may use the location data collected to enhance your use of the Services by providing you with
                        relevant content&nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "54pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        2.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        HOW WE GATHER INFORMATION FROM USERS?
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        How we collect and store information depends on the pages you are visiting, the activities in
                        which you elect to participate and the services provided. For example, you may be asked to
                        provide information when you register for access to certain portions of our Website, create a
                        User account, request certain features, such as e-mail newsletters or when you make a payment.
                        Like most Websites, Foodb also collects information automatically and through the use of
                        electronic tools that may be transparent to our visitors and Users. For example, we may log the
                        name of your Internet Service Provider.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        3.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp;&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        WHAT WE DO WITH THE INFORMATION WE COLLECT?
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Like other Websites, we collect information to enhance your visit and deliver more
                        individualised content. We respect your privacy and do not share your information with anyone,
                        except in cases when that proves necessary.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We will retain the information we collect from you for a period of maximum of 5 /five/ years, or
                        less if it is no longer necessary for the provision of the Foodb services to you. After the
                        expiry of this period we undertake to delete any information we have collected from you.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Aggregate information and information that does not personally identify you, may be used in many
                        ways. For example, Foodb may combine information about your usage patterns on the Website with
                        similar information obtained from other users to help enhance our site and Services (e.g., to
                        learn which pages are visited the most or what features Users find the most attractive). This
                        information does not include any information about you and does not allow anyone to identify you
                        individually. We may use personally identifiable information, collected on the Website, to
                        communicate with you about your registration and customisation preferences; our Terms of Service
                        and Privacy Policy; services and products offered by or through the Website; and other topics we
                        think you might find of interest. Personally identifiable information collected by Foodb may
                        also be used for other purposes, including but not limited to Website administration,
                        troubleshooting, processing of e-commerce transactions and other communications with you.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We strive to always protect your personal payment information. We accept payments with all major
                        credit and debit card providers, such as VISA, Mastercard and others. All payment card
                        transactions made through our payment gateway are processed using a secure online payment
                        gateway (Secure Socket Layer (SSL) technology) that encrypts your card details in a secure
                        hosting environment. We do not hold your payment card details on theFoodb &nbsp;server.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        4.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp;&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        DISCLOSURE
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginRight: "6pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb won't transfer information about you to third parties for the purpose of providing or
                        facilitating third-party advertising to you. We won't sell information about you. We may share
                        your account information with third parties in some circumstances, including: (1) with your
                        consent; (2) to a service provider or partner who meets our data protection standards; (3) when
                        we have a good faith belief it is required by law, such as pursuant to a subpoena or other legal
                        process; (4) when we have a good faith belief that doing so will help prevent imminent harm to
                        someone. If we are going to share your information in response to legal process, we'll give you
                        notice so you can challenge it (for example by seeking court intervention), unless we're
                        prohibited by law or believe doing so may endanger others. We will object to requests for
                        information about users of our services that we believe are improper. Certain third parties who
                        provide technical support for the operation of our Website - our Web hosting service for example
                        - may have access to such information.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        5.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        RIGHT OF CONSENT WITHDRAWAL
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginRight: "6pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        You may withdraw your consent for collecting your personal information at any time. To do so,
                        please contact us at info@tectah.com.&nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginRight: "6pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        6.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        CHANGE OR REVIEW OF INFORMATION
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        If you would like to review, change or delete personal data we have collected from you or you
                        had submitted or permanently delete your account, please contact us.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        For more information regarding the termination or deletion of your information, please refer to
                        Section 8: Termination of this Privacy Policy.&nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        7.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp; &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        ACCESSING &amp; CORRECTING YOUR PERSONAL INFORMATION.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We take reasonable steps to accurately record the personal information that you provide to us,
                        as well as any subsequent updates.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We encourage you to review, update, and correct the personal information that we maintain about
                        you. You may request that we delete personal data about you that is inaccurate, incomplete,
                        irrelevant for legitimate purposes, or is being processed in a way which infringes any
                        applicable legal requirements.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        8.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp;&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        SECURITY: HOW WE PROTECT YOUR INFORMATION?
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb is registered as a Personal Data Controller pursuant to European Union law.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        We have implemented appropriate measures in the form of various technical, physical and other
                        means, including, but not limited to measures regarding the security of our electronic systems
                        and databases. These means aim at improving the integrity and security of the personal
                        information that we collect and maintain. However, please be advised that even the best security
                        measures cannot guarantee the full elimination of all risks. If we learn of any violation,
                        breach or danger to our security systems breach, then we will attempt to notify you
                        electronically so that timely and appropriate protective steps can be taken. Apart from
                        informing you via e-mail, we may post a notice through the Website if a security breach occurs.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Your personal data safety is of utmost importance to us. We review and strive to improve our
                        security measures on a regular basis.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        If we detect a breach of our security measures, which has the potential of harming you as an
                        individual we will notify you without undue delay.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        9.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp; &nbsp;&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        CONTROLLING YOUR PERSONAL DATA
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <br />
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        For more information on how you can control your data shared with us, please see section 4, 5
                        and 6 of the present agreement.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        If you have any questions regarding the ways you can control your personal data, please contact
                        us at info@tectah.com.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        10.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        TERMINATION
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        As mentioned, you may at any time review or change the personal information we maintain about
                        you by contacting Foodb. Upon your request, we will delete your contact information and personal
                        data from our active databases.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        This Privacy Policy is effective until terminated by either party. If you no longer agree to be
                        bound by this Privacy Policy, you must cease the use of the Foodb Website. If you are
                        dissatisfied with Foodb, its content, or any of these terms, conditions, and policies, your sole
                        legal remedy is to discontinue using the Website. Foodb reserves the right to terminate or
                        suspend your access to and use of the Website, or parts of them, without notice, if we believe,
                        in our sole discretion that such use is in violation of any applicable law, or harmful to our
                        interests or the interests of another person or entity, or where Foodb has reasons to believe
                        that their use is in violation of this Privacy Policy or the Terms of Use.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        11.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        CHILDREN'S PRIVACY
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb does not knowingly collect personal information from children under the age of 13. If we
                        learn that we have personal information on a child under the age of 13, we will delete that
                        information from our servers. Foodb encourages parents to go online with their kids.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        12.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        CHANGES TO THIS POLICY
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb reserves the rights to change this Privacy Policy at any time. Please check this page
                        periodically for changes. Your use of the services after any such amendment or change in the
                        Privacy Policy shall be deemed as your express acceptance to such amended/changed Privacy Policy
                        and an assent to be bound by such changed/amended Privacy Policy. Information collected prior to
                        the time any change is posted will be used according to the rules and laws that applied at the
                        time the information was collected.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        13.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        GOVERNING LAW.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        This Privacy Policy and the use of the Website are governed by the laws of the United Kingdom.
                        The parties undertake to first try to resolve the dispute by negotiation. If the parties fail to
                        reach an amicable resolution through negotiation, Foodb agrees to submit the dispute to the
                        competent Court of the United Kingdom.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        14.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        COPYRIGHTS
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        .
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        The copyrights of our Website are the property of Foodb.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Texts, graphics, photographs, animations, videos and clips, visible on the Website are the
                        object of copyright and are part of the intellectual property of Foodb. Those may not be
                        reproduced, used, presented or represented without an explicit written permission by Foodb. Any
                        distribution of files, obtained by the Users under the Terms and Conditions of the Website, or
                        of parts of such files, constitutes a violation of the relevant intellectual property protection
                        laws and is prosecuted by the law.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Nothing contained on this Website may be interpreted as granting a license or right of use as a
                        trademark without the prior explicit written consent of Foodb.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        15.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        MISCELLANEOUS
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb is controlled, operated and administered entirely within the United Kingdom.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        If you are accessing the Foodb Website from another jurisdiction, please be advised that you are
                        transferring your personal information to Foodb in the United Kingdom and, by using the Website,
                        you consent to that transfer and to abide by the applicable laws concerning your use of the
                        Website and your agreements with us.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        This statement and the policies outlined in this Privacy Policy are not intended to and do not
                        create any contractual or other legal rights in or on behalf of any third party.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        Foodb may provide a translation of the English version of the Privacy Policy into other
                        languages. You understand and agree that any translation of the Privacy Policy into other
                        languages is only for your convenience and that the English version shall govern your rights and
                        responsibilities. In case there are any inconsistencies between the English version of the
                        Privacy Policy and its translated versions, the English version of the Terms shall prevail.
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <br />
                        <br />
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "19pt",
                        marginRight: "6pt",
                        textIndent: "-18pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                        padding: "0pt 0pt 0pt 18pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        16.
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: '"Times New Roman",serif',
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;&nbsp;
                    </span>
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 700,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        CONTACT
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "0pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        &nbsp;
                    </span>
                </p>
                <p
                    dir="ltr"
                    style={{
                        lineHeight: "1.7999999999999998",
                        marginLeft: "7pt",
                        marginRight: "7pt",

                        marginTop: "0pt",
                        marginBottom: "12pt",
                    }}
                >
                    <span
                        style={{
                            fontSize: "11pt",
                            fontFamily: "Calibri,sans-serif",
                            color: "#777777",
                            backgroundColor: "transparent",
                            fontWeight: 400,
                            fontStyle: "normal",
                            fontVariant: "normal",
                            textDecoration: "none",
                            verticalAlign: "baseline",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        If you believe Foodb does not adhere to this Privacy Policy, in order to address a question, to
                        resolve a complaint regarding the Website or the Foodb Services, or to receive further
                        information regarding the Services, please contact Foodb via email at info@tectah.com.
                    </span>
                </p>
                <p>
                    <br />
                </p>
                <p>
                    <br />
                </p>
            </>
        </div>
    );
};
export default Privacy;
